import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter
} from 'react-router-dom';
import App from './App';

import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';

ReactDOM.render(
  <BrowserRouter  basename="/qa-test" >
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js